"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollSettings = exports.carouselSettings = exports.BACKDROP_DEVICE_SLICER = exports.BACKDROP_MOBILE_SLICER = exports.BACKDROP_IMAGE_LARGE_OFFSET = exports.BACKDROP_IMAGE_SMALL_OFFSET = exports.MOBILE_CAROUSEL_SIZE = exports.TABLET_CAROUSEL_SIZE = exports.MOBILE_SCROLL_SIZE = exports.TABLET_SCROLL_SIZE = exports.DEVICE_RENDER_ITEMS = exports.PAIRED_CHUNK_SIZE = exports.NOT_PAIRED_CHUNK_SIZE = void 0;
var NOT_PAIRED_CHUNK_SIZE = 5;
exports.NOT_PAIRED_CHUNK_SIZE = NOT_PAIRED_CHUNK_SIZE;
var PAIRED_CHUNK_SIZE = 4;
exports.PAIRED_CHUNK_SIZE = PAIRED_CHUNK_SIZE;
var DEVICE_RENDER_ITEMS = 3;
exports.DEVICE_RENDER_ITEMS = DEVICE_RENDER_ITEMS;
var TABLET_SCROLL_SIZE = 755;
exports.TABLET_SCROLL_SIZE = TABLET_SCROLL_SIZE;
var MOBILE_SCROLL_SIZE = 500;
exports.MOBILE_SCROLL_SIZE = MOBILE_SCROLL_SIZE;
var TABLET_CAROUSEL_SIZE = 600;
exports.TABLET_CAROUSEL_SIZE = TABLET_CAROUSEL_SIZE;
var MOBILE_CAROUSEL_SIZE = 500;
exports.MOBILE_CAROUSEL_SIZE = MOBILE_CAROUSEL_SIZE;
var BACKDROP_IMAGE_SMALL_OFFSET = 50;
exports.BACKDROP_IMAGE_SMALL_OFFSET = BACKDROP_IMAGE_SMALL_OFFSET;
var BACKDROP_IMAGE_LARGE_OFFSET = 100;
exports.BACKDROP_IMAGE_LARGE_OFFSET = BACKDROP_IMAGE_LARGE_OFFSET;
var BACKDROP_MOBILE_SLICER = 2;
exports.BACKDROP_MOBILE_SLICER = BACKDROP_MOBILE_SLICER;
var BACKDROP_DEVICE_SLICER = 1.8;
exports.BACKDROP_DEVICE_SLICER = BACKDROP_DEVICE_SLICER;
var carouselSettings = {
  lazyLoad: 'progressive',
  infinite: true,
  slidesToShow: 1,
  arrows: true,
  swipeToSlide: true,
  dots: false
};
exports.carouselSettings = carouselSettings;
var scrollSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  infinite: false,
  arrows: false,
  dots: false
};
exports.scrollSettings = scrollSettings;